// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"DownloadableContent_pageContainer__2Dpxj","subTitle":"DownloadableContent_subTitle__o6Xa6","action":"DownloadableContent_action__19izg"};